// DERIVADO DE: gestion-web-cliente@1a5ce2d39
//   los mapas `nivelMeta` repetidos en listado-luminarias, popup-generico y
//   jerarquia-luminaria.
// CAMBIOS: uno solo, y con el dato que a IRIX se le escapa: de qué tipografía
//   sale cada ícono.

import type { NivelObjetivo } from 'modelos';

import { FONT_SIMBOLOS, fontSetDeIcono } from '@core/ui/iconos';

export { fontSetDeIcono };

export interface PresentacionNivel {
  readonly etiqueta: string;
  readonly icono: string;
  /**
   * `true` si el ícono vive en **Material Symbols** y no en Material Icons.
   *
   * No es un detalle de estilo: un ligature que la tipografía cargada no tiene
   * **no cae a otro ícono**, escribe el nombre en crudo o dibuja un rectángulo.
   * Es lo que pasaba con la puesta, que se veía como cualquier otra cosa.
   */
  readonly simbolo?: boolean;
}

/**
 * Cómo se dibuja cada nivel de la jerarquía del alumbrado.
 *
 * **Los íconos son los de IRIX a propósito**: son los que el operador ya tiene
 * asociados, y hasta que llegue el manual de marca no hay razón para inventar
 * otros. `table_lamp` es el de la puesta, y sale de Material Symbols.
 */
export const NIVELES: Record<NivelObjetivo, PresentacionNivel> = {
  luminaria: { etiqueta: 'Luminaria', icono: 'lightbulb' },
  grupo: { etiqueta: 'Grupo de luminarias', icono: 'workspaces' },
  puesta: { etiqueta: 'Puesta', icono: 'table_lamp', simbolo: true },
  grupoPuesta: { etiqueta: 'Grupo de puestas', icono: 'hub' },
};

export function etiquetaNivel(nivel: string): string {
  return NIVELES[nivel as NivelObjetivo]?.etiqueta ?? nivel;
}

export function iconoNivel(nivel: string): string {
  return NIVELES[nivel as NivelObjetivo]?.icono ?? 'question_mark';
}

/**
 * Qué tipografía usar para el ícono de ese nivel.
 *
 * Se pasa a `<mat-icon [fontSet]="…">`. Ya da lo mismo: Material Symbols es la
 * fuente por defecto (`core/ui/iconos.ts`).
 *
 * @deprecated Dibujá `<mat-icon>` sin `fontSet`.
 */
export function fontSetNivel(nivel: string): string {
  return NIVELES[nivel as NivelObjetivo]?.simbolo ? FONT_SIMBOLOS : '';
}
